<div class="container-fluid">
  <h1 class="page-header">Value of Lessons Taught Report</h1>

  <mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>Filter</mat-panel-title>
    </mat-expansion-panel-header>
    <form class="form">
      <div class="row">
        <app-week-year-selector
          [showDateRange]="true"
          [initialWeek]="week"
          [initialYear]="year"
          [initialDateRange]="dateTimeRange"
          [showNoneOption]="false"
          dateRangeColClass="col-md-6"
          weekColClass="col-md-3"
          yearColClass="col-md-3"
          (selectionChange)="onWeekYearChange($event)">
        </app-week-year-selector>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field class="full-width-field">
                <mat-label>Show</mat-label>
                <mat-select [(ngModel)]="selectedShow" name="show" (selectionChange)="loadData()">
                  <mat-option *ngFor="let option of showOptions" [value]="option">{{option}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="full-width-field">
                <mat-label>Group By</mat-label>
                <mat-select [(ngModel)]="selectedGroupBy" name="groupBy" (selectionChange)="loadData()">
                  <mat-option *ngFor="let option of groupByOptions" [value]="option">{{option}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field class="full-width-field">
                <mat-label>Student Account</mat-label>
                <input
                  #studentInput
                  name="student"
                  [(ngModel)]="student"
                  (input)="onAutocompleteStudent($event)"
                  matInput
                  [matAutocomplete]="autoCompleteStudent">
                <button (click)="redirectUserProfile(studentInput)" type="button"
                  matSuffix mat-icon-button
                  aria-label="manage_accounts">
                  <mat-icon>manage_accounts</mat-icon>
                </button>
              </mat-form-field>
              <mat-autocomplete #autoCompleteStudent="matAutocomplete"
                (optionSelected)="loadData()">
                <mat-option
                  *ngFor="let option of autoCompleteStudentOptions"
                  [value]="option.label">
                  {{option.label}} ({{option.value}})
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-md-6">
              <mat-form-field class="full-width-field">
                <mat-label>Instructor</mat-label>
                <mat-select
                  [(ngModel)]="instructor"
                  name="instructor"
                  (selectionChange)="loadData()">
                  <mat-option>None</mat-option>
                  <mat-option
                    *ngFor="let element of this._fieldsService.instructorData()"
                    [value]="element.uid">
                    {{ element.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <div class="float-end">
            <button mat-raised-button color="primary" class="me-2" (click)="resetForm()">
              <mat-icon>refresh</mat-icon> Reset
            </button>
            <button style="background-color: transparent !important; border: none;"
              (click)="onPrint()"
              type="button"
              mat-icon-button
              class="mb-1"
              matTooltip="Print value of lessons taught report"
              matTooltipPosition="below"
              aria-label="Print value of lessons taught report">
              <mat-icon style="color: #1C3F8B;">print</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </form>
  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

  <!-- Results Section -->
  <div class="container-fluid mt-3" *ngIf="reportData.length > 0">
    <h2>{{selectedShow}} by {{selectedGroupBy}}</h2>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 full-width">
      <!-- Group By Column -->
      <ng-container matColumnDef="groupByValue">
        <th mat-header-cell *matHeaderCellDef>{{selectedGroupBy}}</th>
        <td mat-cell *matCellDef="let element">{{selectedGroupBy === 'Day' ? reportDateService.formatDate(element.groupByValue) : element.groupByValue}}</td>
        <td mat-footer-cell *matFooterCellDef><strong>Total</strong></td>
      </ng-container>

      <!-- DE Units Column (conditionally displayed) -->
      <ng-container matColumnDef="de_units">
        <th mat-header-cell *matHeaderCellDef>DE Units</th>
        <td mat-cell *matCellDef="let element">{{element.de_units || 0}}</td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>{{getTotalDEUnits()}}</strong>
        </td>
      </ng-container>

      <!-- Pre-Original Units Column (conditionally displayed) -->
      <ng-container matColumnDef="pre_original_units">
        <th mat-header-cell *matHeaderCellDef>Pre-Original Units</th>
        <td mat-cell *matCellDef="let element">{{element.pre_original_units || 0}}</td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>{{getTotalPreOriginalUnits()}}</strong>
        </td>
      </ng-container>

      <!-- Value Column -->
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef>{{selectedShow}}</th>
        <td mat-cell *matCellDef="let element">{{element.value}}</td>
        <td mat-footer-cell *matFooterCellDef>
          <strong>{{getTotalValue()}}</strong>
        </td>
      </ng-container>

      <!-- Unit Cost Column -->
      <ng-container matColumnDef="unit_cost">
        <th mat-header-cell *matHeaderCellDef class="text-end">Total Cost</th>
        <td mat-cell *matCellDef="let element" class="text-end">{{(element.total_cost !== undefined ? element.total_cost : calculateRowTotalCost(element)) | studioCurrency }}</td>
        <td mat-footer-cell *matFooterCellDef class="text-end">
          <strong>{{getTotalCost() | studioCurrency }}</strong>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="getDisplayColumns()"></tr>
      <tr mat-row *matRowDef="let row; columns: getDisplayColumns();"></tr>
      <tr mat-footer-row *matFooterRowDef="getDisplayColumns()"></tr>
    </table>

    <!-- Average Cost Summary (Only for Units Used) -->
    <div *ngIf="selectedShow === 'Units Used'" class="mt-3 text-end">
      <strong>Average Cost Per Unit: {{getAverageUnitCost() | studioCurrency }}</strong>
    </div>
  </div>

  <!-- No Results Message -->
  <div class="container-fluid mt-3" *ngIf="!reportData.length && !ShowProgressBar">
    <div class="alert alert-info">
      No data found for the selected criteria.
    </div>
  </div>

  <!-- Spacing for the bottom of the page -->
  <div class="mt-4" style="height: 100px;"></div>
</div>
